export const LOG_USER_IN = "LOG_USER_IN";
export const LOG_USER_IN_SUCCESS = "LOG_USER_IN_SUCCESS";
export const LOG_USER_IN_FAILURE = "LOG_USER_IN_FAILURE";
export const REGISTER_NEW_USER = "REGISTER_NEW_USER";
export const REGISTER_NEW_USER_SUCCESS = "REGISTER_NEW_USER_SUCCESS";
export const REGISTER_NEW_USER_FAILURE = "REGISTER_NEW_USER_FAILURE";
export const LOG_USER_OUT = "LOG_USER_OUT";
